export const ADVANCED_SETTINGS_DEFAULTS = Object.freeze({
  n_neighbors: 20,
  window: 20,
  n: 3,
  pf_threshold: 15,
  pressure_drop_threshold: 10,
  pressure_drop_abs_threshold: 15,
  salt_passage_threshold: 10,
  min_day_between_cips: 20,
  max_days_between_cips: 180,
  k: 5,
  shutdown_length: 20,
  use_salt_passage: false,
  use_permeability_trigger: false,
  permeability_only: false,
  permeability_threshold: 15,
  permeability_threshold_predict: 15,
  min_time: 0.042,
  max_time: 14,
  min_num_points: 20,
  stabilization_days: 10,
  top_exp: 5,
  max_evals: 10,
  adapt_pf_trend: true,
  adapt_pressure_drop_trend: true,
  pressure_drop_threshold_predict: 10,
  pressure_drop_abs_threshold_predict: 1,
  pressure_drop_threshold_predictCheckbox1: true,
  pressure_drop_threshold_predictCheckbox2: false,
  adapt_salt_passage_trend: true,
  simulation_improve_accuracy: false,
  optimization_target: "Maximize Financial Benefits",
  failure_probability_threshold: 95,
});
